module.exports = __webpack_public_path__ + "static/img/VOLKSWAGEN.a69dae7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/VOLKSWAGEN.png
// module id = kI0b
// module chunks = 1